import { toCurrencyString } from '@thesavingsgroup/utils/toCurrencyString';
import { toDOBString } from '@thesavingsgroup/utils/toDOBString';
import { toNumberString } from '@thesavingsgroup/utils/toNumberString';
import { toPhoneString } from '@thesavingsgroup/utils/toPhoneString';
import { toSSNString } from '@thesavingsgroup/utils/toSSNString';
import toString from 'lodash/toString';

import { NumberInputMasks } from '../types/NumberInputMasks';

/**
 * Picks the formatter for a `NumberInput`'s mask. Every one of them is
 * progressive - it formats however many characters it is given - so it can be
 * applied on each keystroke rather than only on a complete value.
 *
 * With no mask the value is returned as typed. Zip codes are unmasked
 * `NumberInput`s, and grouping `33602` into `33,602` would break them.
 */
export const formatValue = (
  value: string | number | null | undefined,
  { currency, dob, number, phone, ssn }: NumberInputMasks,
): string => {
  if (currency) {
    return toCurrencyString(value);
  }

  if (dob) {
    return toDOBString(value);
  }

  if (number) {
    return toNumberString(value);
  }

  if (phone) {
    return toPhoneString(value);
  }

  if (ssn) {
    return toSSNString(value);
  }

  return toString(value);
};
